export const MOBILE = 920;
export const TABLET = 920;
export const DESKTOP = 1200;

type ObjectMap<T> = { [key: string]: T };

export const BREAKPOINTS: ObjectMap<number> = {
  MOBILE: 920,
  TABLET: 920,
  DESKTOP: 1200,
};

export const MEDIA_QUERIES = {
  MOBILE: `(max-width: ${MOBILE}px)`,
  TABLET: `(max-width:${DESKTOP}px)`,
  DESKTOP: `(min-width: ${DESKTOP}px)`,
};
